/**
 * BILA HEP CENTER
 */
document.addEventListener("DOMContentLoaded", function () {
//   console.log("Help Center Script Loaded");
//   console.log("AJAX URL:", helpCenterAjax.ajax_url);
//   console.log("Nonce:", helpCenterAjax.nonce);

  // Initialize on page load
  initHelpCenter();

  // Function to initialize all help center functionality
  function initHelpCenter() {
    initCategorySwitching();
    initAccordion();
    initSearch();
  }

  // Handle Category Switching
  function initCategorySwitching() {
    const categoryLinks = document.querySelectorAll(".category-link");

    categoryLinks.forEach((link) => {
      link.addEventListener("click", function (e) {
        e.preventDefault();

        // Update active category
        categoryLinks.forEach((l) => l.classList.remove("active"));
        this.classList.add("active");

        // Show loading state
        const helpAccordion = document.getElementById("helpAccordion");
        if (!helpAccordion) return;

        helpAccordion.innerHTML = `
                    <div class="help-center-loading">
                        <div class="loading-spinner"></div>
                    </div>
                `;

        // Get category data
        const categoryId = this.dataset.categoryId;
        const categorySlug = this.dataset.categorySlug;
        const categoryName = this.textContent.replace(/\d+/g, "").trim();

        // Fetch questions for this category
        fetchQuestionsByCategory(categoryId, categorySlug, categoryName);
      });
    });
  }

  // Handle Accordion Toggle
  function initAccordion() {
    const accordionItems = document.querySelectorAll(".help-accordion-item");

    accordionItems.forEach((item) => {
      const header = item.querySelector(".help-accordion-header");
      const content = item.querySelector(".help-accordion-content");

      // Remove existing event listeners to prevent duplicates
      header.replaceWith(header.cloneNode(true));
      const newHeader = item.querySelector(".help-accordion-header");

      newHeader.addEventListener("click", function () {
        // Close all other accordion items
        accordionItems.forEach((otherItem) => {
          if (otherItem !== item) {
            otherItem.classList.remove("active");
            const otherContent = otherItem.querySelector(
              ".help-accordion-content",
            );
            if (otherContent) {
              otherContent.style.maxHeight = null;
            }
          }
        });

        // Toggle current item
        const isActive = item.classList.contains("active");

        if (!isActive) {
          item.classList.add("active");
          if (content) {
            content.style.maxHeight = "100%";
            // Smooth scroll to item
            setTimeout(() => {
              scrollToAccordionItem(item);
            }, 300);
          }
        } else {
          item.classList.remove("active");
          if (content) {
            content.style.maxHeight = null;
          }
        }
      });
    });

    // Auto-expand first item if none are expanded
    const hasActive = document.querySelector(".help-accordion-item.active");
    if (!hasActive && accordionItems.length > 0) {
      const firstItem = accordionItems[0];
      const firstContent = firstItem.querySelector(".help-accordion-content");
      firstItem.classList.add("active");
      if (firstContent) {
        firstContent.style.maxHeight = "100%";
      }
    }
  }

  // Function to fetch questions by category
  function fetchQuestionsByCategory(categoryId, categorySlug, categoryName) {
    const helpAccordion = document.getElementById("helpAccordion");
    if (!helpAccordion) return;

    const data = new FormData();
    data.append("action", "get_help_questions");
    data.append("category_id", categoryId);
    data.append("nonce", helpCenterAjax.nonce);

    fetch(helpCenterAjax.ajax_url, {
      method: "POST",
      body: data,
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        if (data.success) {
          updateQuestionsAccordion(data.data.questions, categoryName);
          // Reinitialize accordion after content is loaded
          setTimeout(initAccordion, 50);
        } else {
          throw new Error(data.data || "Unknown error");
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        helpAccordion.innerHTML = `
                <div class="no-questions">
                    <div class="no-questions-icon"><i class="icon-73"></i></div>
                    <h3>Error loading questions</h3>
                    <p>${error.message || "Please try again later."}</p>
                </div>
            `;
      });
  }

  // Function to update accordion with new questions
  function updateQuestionsAccordion(questions, categoryName) {
    const helpAccordion = document.getElementById("helpAccordion");
    if (!helpAccordion) return;

    if (!questions || questions.length === 0) {
      helpAccordion.innerHTML = `
                <div class="no-questions">
                    <div class="no-questions-icon">?</div>
                    <h3>No questions found in "${categoryName}"</h3>
                    <p>Check back soon or try another category.</p>
                </div>
            `;
      return;
    }

    let accordionHTML = "";

    questions.forEach((question, index) => {
      const activeClass = index === 0 ? "active" : "";
      const formattedDate = new Date(question.date).toLocaleDateString(
        "en-US",
        {
          year: "numeric",
          month: "long",
          day: "numeric",
        },
      );

      // Sanitize content to prevent XSS
      const sanitizedContent = question.excerpt || "";

      const permalink = question.permalink;
      let question_link = "";

      if (permalink.length) {
        question_link = `<a class="more" href="${permalink}" title="${question.link_text}">${question.link_text}</a>`;
      }

      accordionHTML += `
                <div class="help-accordion-item ${activeClass}" data-question-id="${question.id}">
                    <div class="help-accordion-header">
                        <h3 class="h4">${question.title || "Untitled"}</h3>
                        <div class="help-accordion-icon">
                            <svg viewBox="0 0 24 24" width="24" height="24">
                                <path d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z"/>
                            </svg>
                        </div>
                    </div>
                    <div class="help-accordion-content" style="${index === 0 ? "max-height: 100% !important" : "max-height: 0"}">
                        <div class="help-accordion-body">
                            <p>${sanitizedContent}</p>
                            ${question_link}
                            
                            <div class="help-question-meta">
                                <div class="meta-item">
                                    <span class="meta-icon"><i class="icon-1"></i></span>
                                    ${question.categories ? question.categories.join(", ") : "Uncategorized"}
                                </div>
                                <div class="meta-item">
                                    <span class="meta-icon"><i class="icon-27"></i></span>
                                    ${formattedDate}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            `;
    });

    helpAccordion.innerHTML = accordionHTML;
  }

  // Smooth scroll to accordion when opened
  function scrollToAccordionItem(item) {
    if (!item) return;

    const headerOffset = 250;
    const elementPosition = item.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    });
  }

  // Search functionality (optional)
  function initSearch() {
    const searchInput = document.getElementById("helpSearch");
    const searchBtn = document.getElementById("helpSearchBtn");

    if (searchInput && searchBtn) {
      searchBtn.addEventListener("click", performSearch);
      searchInput.addEventListener("keypress", function (e) {
        if (e.key === "Enter") {
          performSearch();
        }
      });
    }

    function performSearch() {
      const searchTerm = searchInput.value.trim();
      if (searchTerm) {
        // Implement search functionality here
        // console.log("Searching for:", searchTerm);
      }
    }
  }

  // Make functions available globally if needed
  window.reinitHelpAccordion = initAccordion;
  window.fetchHelpQuestions = fetchQuestionsByCategory;
});
